export default `---
slug: ireland
country: Ireland
countryCode: IRL
continent: Europe
year: 2019
title: "Ireland"
description: "The Emerald Isle — Guinness, green cliffs, and the friendliest people in Europe."
thumbnail: /images/travels/IRL/ireland_thumb.jpg
relatedLinks: []
---
![ireland](/images/travels/IRL/ireland_thumb.jpg)

*Story coming soon — stay tuned!*

I visited Ireland and it was an incredible experience. Full story and photos are being written up and will appear here soon.
`;
